/**
 * Created by emma on 16/9/21.
 */
import {basepath} from 'config';

var routeConfig = {
    path: basepath + '/',
    getIndexRoute: function (location, cb) {
        require.ensure([], function (require) {
            cb(null, {
                component: require('./home/index.jsx')
            })
        })
    },
    getChildRoutes: function (location, callback) {
        require.ensure([], function (require) {
            callback(null, [
                require('./post/route.js'),
                require('./user/route.js'),
                require('./case/route.js')
            ])
        })
    }
};

export default routeConfig;


// WEBPACK FOOTER //
// ./pages/router.js